import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelinePropertiesPage',
  setup(__props) {

    document.title = "Configure properties"

    const tid = useOrganizationUnitId()
    const id = useId()

    const datasetId = ref()
    const connectorId = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useDatasetPropertyNamesQuery,
        useConnectorPropertyNamesQuery,
        useExcludePipelineDatasetPropertyCommand,
        useIncludePipelineDatasetPropertyCommand,
        useExcludePipelineConnectorPropertyCommand,
        useIncludePipelineConnectorPropertyCommand
    } = useAdminConfigurePipelinePropertiesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.DatasetProperties)
    const connectorProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.ConnectorProperties)

    const { runDatasetPropertyNamesQueryV1, modelDatasetPropertyNamesQueryV1 } = useDatasetPropertyNamesQuery(datasetId)
    const datasetPropertyNames = computed<string>(() => modelDatasetPropertyNamesQueryV1.value?.PropertyNames || [])

    const { runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const connectorPropertyNames = computed<string>(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeIncludePipelineDatasetPropertyCommandV1, succeedIncludePipelineDatasetPropertyCommandV1 } = useIncludePipelineDatasetPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineDatasetPropertyCommandV1, succeedExcludePipelineDatasetPropertyCommandV1 } = useExcludePipelineDatasetPropertyCommand(id, tid, userId)

    const { invokeIncludePipelineConnectorPropertyCommandV1, succeedIncludePipelineConnectorPropertyCommandV1 } = useIncludePipelineConnectorPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineConnectorPropertyCommandV1, succeedExcludePipelineConnectorPropertyCommandV1 } = useExcludePipelineConnectorPropertyCommand(id, tid, userId)

    const availableDatasetPropertyNames = computed(() => datasetPropertyNames.value.filter(p => !datasetProperties.value.includes(p)))
    const availableConnectorPropertyNames = computed(() => connectorPropertyNames.value.filter(p => !connectorProperties.value.includes(p)))

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

    watch(connectorId, () => {
        runConnectorPropertyNamesQueryV1()
    })

    watch(datasetId, () => {
        runDatasetPropertyNamesQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        datasetId.value = modelPipelineDetailsQueryV1.value.DatasetId
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
    })

    watch([
        succeedIncludePipelineDatasetPropertyCommandV1,
        succeedExcludePipelineDatasetPropertyCommandV1,
        succeedIncludePipelineConnectorPropertyCommandV1,
        succeedExcludePipelineConnectorPropertyCommandV1
    ], () => runPipelineDetailsQueryV1())

    function handleIncludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleIncludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

return { __sfc: true,tid, id, datasetId, connectorId, useCurrentUserQuery, usePipelineDetailsQuery, useDatasetPropertyNamesQuery, useConnectorPropertyNamesQuery, useExcludePipelineDatasetPropertyCommand, useIncludePipelineDatasetPropertyCommand, useExcludePipelineConnectorPropertyCommand, useIncludePipelineConnectorPropertyCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, datasetProperties, connectorProperties, runDatasetPropertyNamesQueryV1, modelDatasetPropertyNamesQueryV1, datasetPropertyNames, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1, connectorPropertyNames, invokeIncludePipelineDatasetPropertyCommandV1, succeedIncludePipelineDatasetPropertyCommandV1, invokeExcludePipelineDatasetPropertyCommandV1, succeedExcludePipelineDatasetPropertyCommandV1, invokeIncludePipelineConnectorPropertyCommandV1, succeedIncludePipelineConnectorPropertyCommandV1, invokeExcludePipelineConnectorPropertyCommandV1, succeedExcludePipelineConnectorPropertyCommandV1, availableDatasetPropertyNames, availableConnectorPropertyNames, handleIncludePipelineDatasetPropertyCommandV1, handleExcludePipelineDatasetPropertyCommandV1, handleIncludePipelineConnectorPropertyCommandV1, handleExcludePipelineConnectorPropertyCommandV1 }
}

})